// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__H6Vfm","left":"styles_left__2eCjR"};